/**
 * @flow
 */
import ENV from '../env.json';

export function getAnalyticsConfig(args: {
  env?: 'production' | 'development'
}): {
  analyticsEnabled: boolean,
} {
  const currentArgs = args ?? {};

  const { env } = currentArgs;

  const isDev: boolean = process.env.REACT_APP_DEVELOPMENT === 'true';
  const isStaging: boolean = process.env.REACT_APP_STAGING === 'true';

  const currentEnv = env ?? (isDev ? 'development' : 'production');

  return {
    analyticsEnabled: !isStaging, // if we want to extend use cases for this in the future we can
    AMPLITUDE_API_KEY: ENV[currentEnv].AMPLITUDE.API_KEY,
  };
}
